import { Component } from 'react';
import { connect } from 'react-redux';
import { getThemePath } from '../../selectors/themeSelectors';
import { makeAsyncComponent } from '../../utils/makeAsyncUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncColorPickerField = makeAsyncComponent(() => import( /* webpackChunkName: 'ColorPickerField' */'ContentComponents/components/cmv2/fields/ColorPicker'));
const mapStateToProps = state => ({
  themePath: getThemePath(state)
});
class ColorPicker extends Component {
  render() {
    return /*#__PURE__*/_jsx(AsyncColorPickerField, Object.assign({}, this.props));
  }
}
export default connect(mapStateToProps)(ColorPicker);